export const MotelRoom666Dialogues: any[] = [
    {
        id: 1,
        dialogue: [
            "As Alex pushes open the creaky door, a musty smell hits him. He steps into the dimly lit room, his eyes darting around, taking in the worn-out furniture and the peeling wallpaper. 'I need to get out of here,' he mutters to himself."
        ],
        options: [
            { id: 1, action: "Look around for clues" },
            { id: 2, action: "Try to leave the room" }
        ]
    },
    {
        id: 2,
        dialogue: [
            "As Alex tries to open the door, he realizes it's locked. 'What the hell?' he mutters, trying to force the door open. 'I need to get out of here.'"
        ],
        options: [
            { id: 1, action: "Look around for clues" }
        ]
    },
    {
        id: 3,
        dialogue: [
            "As Alex looks around the room, he notices a piece of paper sticking out from under the bed and a plush children's toy."
        ],
        options: [
            { id: 1, action: "Read the paper" },
            { id: 2, action: "Pick up the plush toy" }
        ]
    },
    {
        id: 4,
        dialogue: [
            "The paper is a note that reads: 'Dad please don't leave me here. I'm scared. I want to go home. I miss mom. I miss you. He's gonna hurt me. - Emily.' Alex feels a chill run down his spine. 'What the hell is this?' he mutters, crumpling the paper in his hand. 'I need to get out of here and find Emily.'"
        ],
        options: [
            { id: 1, action: "Pick up the plush toy" }
        ]
    },
    {
        id: 5,
        dialogue: [
            "As Alex picks up the plush toy, he notices it's from Emily. 'Why, why, why my daughter?' As he holds the plush toy close to his chest, he feels a sense of urgency to find her. When he looks at the plush toy, he notices a small key attached to it. 'What's this?' he mutters, taking the key off the plush toy. 'I need to get out of here and find Emily.'"
        ],
        options: [
            { id: 1, action: "Try to leave the room" }
        ]
    },
    {
        id: 6,
        dialogue: [
            "As Alex tries to open the door, he realizes it's the wrong key. 'What the hell?' he mutters, trying to force the door open. 'There must be another key hidden.'"
        ],
        options: [
            { id: 1, action: "Look around for more clues" }
        ]
    },
    {
        id: 7,
        dialogue: [
            "As Alex looks around the room, he notices a nightstand in the corner."
        ],
        options: [
            { id: 1, action: "Search the nightstand" },
            { id: 2, action: "Continue searching the room" }
        ]
    },
    {
        id: 8,
        dialogue: [
            "Alex carefully opens the nightstand, his heart pounding in his chest. Inside, he finds an old, dusty book. He flips it open and a key falls out from between the pages. 'Could this be it?' he wonders, picking up the key. 'Could this be the key to the door?'"
        ],
        options: [
            { id: 1, action: "Try the new key on the door" },
            { id: 2, action: "Read the book" },
            { id: 3, action: "Continue searching the room" }
        ]
    },
    
    {
        id: 9,
        dialogue: [
            "As Alex tries the key on the door, he hears a click. But suddenly, the MotelPhone rings. 'What the hell?' he mutters, picking up the phone. 'Hello?' he says, his voice shaking. 'You can't escape,' a voice whispers on the other end. 'You're not leaving this shithole alive.' Alex feels a chill run down his spine. 'What the hell is this?' he mutters, slamming the phone down. 'I need to get out of here and find Emily.'"
        ],
        options: [
            { id: 1, action: "Continue searching the hallway" },
            { id: 2, action: "Continue searching the room" }
        ]
    },
    {
        id: 10,
        dialogue: [
            "As Alex flips through the book, he finds a passage that catches his eye. 'He's coming for me,' it reads. 'I can hear him outside the door. I'm so scared. I don't know what to do.' Under the passage, there's a drawing of a plush toy with a 3-digit number written next to it: 666. Alex feels a chill run down his spine. 'What the hell is this?' he mutters, closing the book. 'I need to get out of here and find Emily.'"
        ],
        options: [
            { id: 1, action: "Try the new key on the door" },
            { id: 2, action: "Continue searching the room" }
        ]
    },
    {
        id: 11,
        dialogue: [
            "As Alex looks around the room, he notices a closet in the corner. He opens the door and a strange smell hits him. Inside, he finds clothes drenched in blood. As he looks at the bottom of the closet, he sees a 3-digit number written in blood: 726."
        ],
        options: [
            { id: 1, action: "Write the numbers down" },
            { id: 2, action: "Try the new key on the door" }
        ]
    },
    {
        id: 12,
        dialogue: [
            "Maybe the numbers are a code to unlock the door or something else to find Emily. 'I need to get out of here and find Emily as fast as possible,' Alex mutters to himself."
        ],
        options: [
            { id: 1, action: "Try the new key on the door" }
        ]
    }
];